import { FREE_SHIPPING } from 'src/constants/shipping';

export const KEYWORDS = `Workwear tailored to all industry sectors and working environments from events to industrial workwear. FREE Delivery on ALL orders over ${FREE_SHIPPING}.`;

export { FREE_SHIPPING };
